import { useEffect, useRef } from 'react';
import { safeString } from '@/lib/utils';
import MessageBubble from './MessageBubble';
import ActionForm from './ActionForm';
import ActionResult from './ActionResult';
import WelcomeScreen from './WelcomeScreen';

export default function MessageList({ messages, isStreaming, onFormSubmit, onSuggestionClick }) {
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isStreaming]);

  if (messages.length === 0) {
    return <WelcomeScreen onSuggestionClick={onSuggestionClick} />;
  }

  return (
    <div className="h-full overflow-y-auto px-4 py-6 space-y-4 scrollbar-thin">
      {messages.map((msg, idx) => {
        if (msg.type === 'step_result') {
          return <ActionResult key={idx} results={msg.content} />;
        }

        if (msg.type === 'error') {
          return (
            <div key={idx} className="bg-destructive/10 text-destructive rounded-lg p-3 text-sm">
              {safeString(msg.content, 'An error occurred')}
            </div>
          );
        }

        if (msg.type === 'form' && msg.formData) {
          return (
            <div key={idx}>
              <MessageBubble role="assistant" content={msg.content} />
              <ActionForm
                formData={msg.formData}
                onSubmit={onFormSubmit}
                isLatest={idx === messages.length - 1}
              />
            </div>
          );
        }

        return (
          <MessageBubble
            key={idx}
            role={msg.role}
            content={msg.content}
            isStreaming={msg.isStreaming}
          />
        );
      })}

      <div ref={endRef} />
    </div>
  );
}
